import { conditionFormChecker, putField } from "../../../../utils/form";
import { createColumnInput, createColumnBoolean } from "../../../../components/table/c-table.logic";
import i18n from "../../../../i18n";
import { createFieldInput, createFieldCheckbox, } from "../../../../components/input/template-builder/template-builder.logic";
import lodash from "lodash";
import { defineAsyncComponent } from "vue";

export const CIcon = defineAsyncComponent(() => import("../../../../components/icon/CIcon"));

export const createColumns = () => {
    const columns = [
        createColumnInput({ title: () => i18n.global.t("model.pictogram.name"), titleCsv: () => i18n.global.t("model.pictogram.name"), dataIndex: "name", align: "center", }),
        createColumnBoolean({ title: () => { return (<CIcon file="pictogram1.svg" class="text-50"></CIcon>)}, titleCsv: () => i18n.global.t("model.pictogram.isPictogram1"), inputProp: () => ({ placeholder: i18n.global.t("model.pictogram.booleanPlaceholder") }), dataIndex: "isPictogram1", align: "center" }),
        createColumnBoolean({ title: () => { return (<CIcon file="pictogram2.svg" class="text-50"></CIcon>)}, titleCsv: () => i18n.global.t("model.pictogram.isPictogram2"), inputProp: () => ({ placeholder: i18n.global.t("model.pictogram.booleanPlaceholder") }), dataIndex: "isPictogram2", align: "center" }),
        createColumnBoolean({ title: () => { return (<CIcon file="pictogram3.svg" class="text-50"></CIcon>)}, titleCsv: () => i18n.global.t("model.pictogram.isPictogram3"), inputProp: () => ({ placeholder: i18n.global.t("model.pictogram.booleanPlaceholder") }), dataIndex: "isPictogram3", align: "center" }),
        createColumnBoolean({ title: () => { return (<CIcon file="pictogram4.svg" class="text-50"></CIcon>)}, titleCsv: () => i18n.global.t("model.pictogram.isPictogram4"), inputProp: () => ({ placeholder: i18n.global.t("model.pictogram.booleanPlaceholder") }), dataIndex: "isPictogram4", align: "center" }),
        createColumnBoolean({ title: () => { return (<CIcon file="pictogram5.svg" class="text-50"></CIcon>)}, titleCsv: () => i18n.global.t("model.pictogram.isPictogram5"), inputProp: () => ({ placeholder: i18n.global.t("model.pictogram.booleanPlaceholder") }), dataIndex: "isPictogram5", align: "center" }),
        createColumnBoolean({ title: () => { return (<CIcon file="pictogram6.svg" class="text-50"></CIcon>)}, titleCsv: () => i18n.global.t("model.pictogram.isPictogram6"), inputProp: () => ({ placeholder: i18n.global.t("model.pictogram.booleanPlaceholder") }), dataIndex: "isPictogram6", align: "center" }),
        createColumnBoolean({ title: () => { return (<CIcon file="pictogram7.svg" class="text-50"></CIcon>)}, titleCsv: () => i18n.global.t("model.pictogram.isPictogram7"), inputProp: () => ({ placeholder: i18n.global.t("model.pictogram.booleanPlaceholder") }), dataIndex: "isPictogram7", align: "center" }),
        createColumnBoolean({ title: () => { return (<CIcon file="pictogram8.svg" class="text-50"></CIcon>)}, titleCsv: () => i18n.global.t("model.pictogram.isPictogram8"), inputProp: () => ({ placeholder: i18n.global.t("model.pictogram.booleanPlaceholder") }), dataIndex: "isPictogram8", align: "center" }),
        createColumnBoolean({ title: () => { return (<CIcon file="pictogram9.svg" class="text-50"></CIcon>)}, titleCsv: () => i18n.global.t("model.pictogram.isPictogram9"), inputProp: () => ({ placeholder: i18n.global.t("model.pictogram.booleanPlaceholder") }), dataIndex: "isPictogram9", align: "center" }),
    ]
    return columns
}

export const createField = ({ props, data, key}) => {
    const { viewOnly } = props;
    const { useForm } = data;
    const { modelRef } = useForm;
    const model = key ? lodash.get(modelRef, key) : modelRef;
    const prefix = key ? `${key}.` : "";
    return putField({
        data,
        fields: [
            createFieldInput({
                visible: ({ field }) => conditionFormChecker({ props, data, executeKey: "visibleField", params: { field } }),
                key: "name",
                colProp: () => ({ xs: 24, md: 12 }),
                formItemProp: () => ({ labelCol: { xs: 24, md: 12 }, wrapperCol: { xs: 24, md: 12 } }),
                label: () => i18n.global.t("model.pictogram.name"),
                inputProp: () => ({
                    disabled: viewOnly,
                    value: modelRef.name,
                    "onUpdate:value": value => (modelRef.name = value),
                })
            }),
            createFieldCheckbox({
                visible: ({ field }) => conditionFormChecker({ props, data, executeKey: "visibleField", params: { field } }),
                key: `${prefix}isPictogram1`,
                colProp: () => ({ xs: 24, md: 12 }),
                formItemProp: () => ({ labelCol: { xs: 24, md: 12 }, wrapperCol: { xs: 24, md: 12 } }),
                label: () => i18n.global.t("model.pictogram.isPictogram1"),
                labelRender: () => { return (<CIcon file="pictogram1.svg" class="text-50"></CIcon>) },
                inputProp: ({ field }) =>
                    lodash.merge(
                        {
                            checked: model.isPictogram1,
                            "onUpdate:checked": checked => {
                                modelRef.isPictogram1 = checked;
                            },
                            disabled: viewOnly,
                        },
                        conditionFormChecker({ props, data, executeKey: "checkboxField", params: { field } })
                    )
            }),
            createFieldCheckbox({
                visible: ({ field }) => conditionFormChecker({ props, data, executeKey: "visibleField", params: { field } }),
                key: `${prefix}isPictogram2`,
                colProp: () => ({ xs: 24, md: 12 }),
                formItemProp: () => ({ labelCol: { xs: 24, md: 12 }, wrapperCol: { xs: 24, md: 12 } }),
                label: () => i18n.global.t("model.pictogram.isPictogram2"),
                labelRender: () => { return (<CIcon file="pictogram2.svg" class="text-50"></CIcon>) },
                inputProp: ({ field }) =>
                    lodash.merge(
                        {
                            checked: modelRef.isPictogram2,
                            "onUpdate:checked": checked => {
                                modelRef.isPictogram2 = checked;
                            },
                            disabled: viewOnly,
                        },
                        conditionFormChecker({ props, data, executeKey: "checkboxField", params: { field } })
                    )
            }),
            createFieldCheckbox({
                visible: ({ field }) => conditionFormChecker({ props, data, executeKey: "visibleField", params: { field } }),
                key: `${prefix}isPictogram3`,
                colProp: () => ({ xs: 24, md: 12 }),
                formItemProp: () => ({ labelCol: { xs: 24, md: 12 }, wrapperCol: { xs: 24, md: 12 } }),
                label: () => i18n.global.t("model.pictogram.isPictogram3"),
                labelRender: () => { return (<CIcon file="pictogram3.svg" class="text-50"></CIcon>) },
                inputProp: ({ field }) =>
                    lodash.merge(
                        {
                            checked: modelRef.isPictogram3,
                            "onUpdate:checked": checked => {
                                modelRef.isPictogram3 = checked;
                            },
                            disabled: viewOnly,
                        },
                        conditionFormChecker({ props, data, executeKey: "checkboxField", params: { field } })
                    )
            }),
            createFieldCheckbox({
                visible: ({ field }) => conditionFormChecker({ props, data, executeKey: "visibleField", params: { field } }),
                key: `${prefix}isPictogram4`,
                colProp: () => ({ xs: 24, md: 12 }),
                formItemProp: () => ({ labelCol: { xs: 24, md: 12 }, wrapperCol: { xs: 24, md: 12 } }),
                label: () => i18n.global.t("model.pictogram.isPictogram4"),
                labelRender: () => { return (<CIcon file="pictogram4.svg" class="text-50"></CIcon>) },
                inputProp: ({ field }) =>
                    lodash.merge(
                        {
                            checked: modelRef.isPictogram4,
                            "onUpdate:checked": checked => {
                                modelRef.isPictogram4 = checked;
                            },
                            disabled: viewOnly,
                        },
                        conditionFormChecker({ props, data, executeKey: "checkboxField", params: { field } })
                    )
            }),
            createFieldCheckbox({
                visible: ({ field }) => conditionFormChecker({ props, data, executeKey: "visibleField", params: { field } }),
                key: `${prefix}isPictogram5`,
                colProp: () => ({ xs: 24, md: 12 }),
                formItemProp: () => ({ labelCol: { xs: 24, md: 12 }, wrapperCol: { xs: 24, md: 12 } }),
                label: () => i18n.global.t("model.pictogram.isPictogram5"),
                labelRender: () => { return (<CIcon file="pictogram5.svg" class="text-50"></CIcon>) },
                inputProp: ({ field }) =>
                    lodash.merge(
                        {
                            checked: modelRef.isPictogram5,
                            "onUpdate:checked": checked => {
                                modelRef.isPictogram5 = checked;
                            },
                            disabled: viewOnly,
                        },
                        conditionFormChecker({ props, data, executeKey: "checkboxField", params: { field } })
                    )
            }),
            createFieldCheckbox({
                visible: ({ field }) => conditionFormChecker({ props, data, executeKey: "visibleField", params: { field } }),
                key: `${prefix}isPictogram6`,
                colProp: () => ({ xs: 24, md: 12 }),
                formItemProp: () => ({ labelCol: { xs: 24, md: 12 }, wrapperCol: { xs: 24, md: 12 } }),
                label: () => i18n.global.t("model.pictogram.isPictogram6"),
                labelRender: () => { return (<CIcon file="pictogram6.svg" class="text-50"></CIcon>) },
                inputProp: ({ field }) =>
                    lodash.merge(
                        {
                            checked: modelRef.isPictogram6,
                            "onUpdate:checked": checked => {
                                modelRef.isPictogram6 = checked;
                            },
                            disabled: viewOnly,
                        },
                        conditionFormChecker({ props, data, executeKey: "checkboxField", params: { field } })
                    )
            }),
            createFieldCheckbox({
                visible: ({ field }) => conditionFormChecker({ props, data, executeKey: "visibleField", params: { field } }),
                key: `${prefix}isPictogram7`,
                colProp: () => ({ xs: 24, md: 12 }),
                formItemProp: () => ({ labelCol: { xs: 24, md: 12 }, wrapperCol: { xs: 24, md: 12 } }),
                label: () => i18n.global.t("model.pictogram.isPictogram7"),
                labelRender: () => { return (<CIcon file="pictogram7.svg" class="text-50"></CIcon>) },
                inputProp: ({ field }) =>
                    lodash.merge(
                        {
                            checked: modelRef.isPictogram7,
                            "onUpdate:checked": checked => {
                                modelRef.isPictogram7 = checked;
                            },
                            disabled: viewOnly,
                        },
                        conditionFormChecker({ props, data, executeKey: "checkboxField", params: { field } })
                    )
            }),
            createFieldCheckbox({
                visible: ({ field }) => conditionFormChecker({ props, data, executeKey: "visibleField", params: { field } }),
                key: `${prefix}isPictogram8`,
                colProp: () => ({ xs: 24, md: 12 }),
                formItemProp: () => ({ labelCol: { xs: 24, md: 12 }, wrapperCol: { xs: 24, md: 12 } }),
                label: () => i18n.global.t("model.pictogram.isPictogram8"),
                labelRender: () => { return (<CIcon file="pictogram8.svg" class="text-50"></CIcon>) },
                inputProp: ({ field }) =>
                    lodash.merge(
                        {
                            checked: modelRef.isPictogram8,
                            "onUpdate:checked": checked => {
                                modelRef.isPictogram8 = checked;
                            },
                            disabled: viewOnly,
                        },
                        conditionFormChecker({ props, data, executeKey: "checkboxField", params: { field } })
                    )
            }),
            createFieldCheckbox({
                visible: ({ field }) => conditionFormChecker({ props, data, executeKey: "visibleField", params: { field } }),
                key: `${prefix}isPictogram9`,
                colProp: () => ({ xs: 24, md: 12 }),
                formItemProp: () => ({ labelCol: { xs: 24, md: 12 }, wrapperCol: { xs: 24, md: 12 } }),
                label: () => i18n.global.t("model.pictogram.isPictogram9"),
                labelRender: () => { return (<CIcon file="pictogram9.svg" class="text-50"></CIcon>) },
                inputProp: ({ field }) =>
                    lodash.merge(
                        {
                            checked: modelRef.isPictogram9,
                            "onUpdate:checked": checked => {
                                modelRef.isPictogram9 = checked;
                            },
                            disabled: viewOnly,
                        },
                        conditionFormChecker({ props, data, executeKey: "checkboxField", params: { field } })
                    )
            }),
        ]
    });
};